__turbopack_context__.v({
  "Button": "index-module__M7bwdW__Button",
  "Item": "index-module__M7bwdW__Item",
  "Popup": "index-module__M7bwdW__Popup",
  "Positioner": "index-module__M7bwdW__Positioner",
  "Separator": "index-module__M7bwdW__Separator",
  "SubmenuTrigger": "index-module__M7bwdW__SubmenuTrigger",
});
